import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Image,
  Switch,
  List,
  InputNumber,
  TreeSelect,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  SearchOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { AiFillDelete, AiOutlineUnlock } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";
import { blogActions, fileManagerActions } from "../../store";

import debounce from "lodash.debounce";
import UploadFile from "../../components/UploadFile";
import categoryApi from "../../api/blog/categoryApi";
import ENV from "../../consts/config";
import slugify from "slugify";
import Swal from "sweetalert2";
import InputColor from "react-input-color";
import { list_to_tree } from "../../utils/index";

const ArticleCategory = (props) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const dispatch = useDispatch();
  const { TextArea } = Input;
  const confirm = Modal.confirm;
  const { TreeNode } = TreeSelect;
  const [treeLine, setTreeLine] = useState(true);
  const [showLeafIcon, setShowLeafIcon] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState();
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [IsEdit, setIsEdit] = useState(false);
  const [btnDeleted, setBtnDeleted] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [colorBg, setColorBg] = useState({
    h: 88,
    s: 65,
    v: 71,
    r: 127,
    g: 182,
    b: 64,
    a: 100,
    hex: "#7fb640",
    rgba: "rgba(127,182,64,1)",
  });
  const [inputFilter, setFilter] = useState({
    name: null,
    display: null,
    displayHome: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const { lstCategory, totalCount } = useSelector((x) => x.blog);
  const [categorySelect, setCategorySelect] = useState([]);
  const { fileImageUrl } = useSelector((x) => x.fileManager);

  useEffect(() => {
    getCategory();
    getCategorySelect();
    form.setFieldsValue(valueForm);
  }, [inputFilter, valueForm]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, page: 1,name: e.target.value });
  };

  const getCateDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getCategory = () => {
    setLoading(true);
    dispatch(blogActions.getCategories(inputFilter)).then(() => {
      setLoading(false);
    });
  };

  const getCategorySelect = () => {
    const params = { display: true, page: 1, limit: 10000 };
    categoryApi.getCategories(params).then((res) => {
      if (res) {
        const cate = res?.results.map((item) => {
          return {
            title: item.name,
            value: item.id,
            id: item.id,
            parentId: item.parent?.id || "0",
            parentName: item.parent?.name || "",
            children: null,
          };
        });
        cate.unshift({
          title: "Chuyên mục gốc",
          value: "0",
          id: "0",
          children: null,
          parentId: "0",
        });
        const list = list_to_tree(cate);
        setCategorySelect(list);
      }
    });
  };

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      name: inputFilter.name,
      display: inputFilter.display,
      displayHome: inputFilter.displayHome,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    // {
    //   title: "Ảnh hiển thị",
    //   dataIndex: "image",
    //   key: "image",
    //   render: (image) => (
    //     <>
    //       {image && (
    //         <Image
    //           width={100}
    //           height={100}
    //           style={{ objectFit: "contain" }}
    //           src={`${ENV.CDN_URL}${image}`}
    //           alt="avatar"
    //         />
    //       )}
    //       {!image && (
    //         <Image
    //           width={100}
    //           src="error"
    //           fallback={ENV.IMAGE_EMPTY}
    //           alt="avatar"
    //         />
    //       )}
    //     </>
    //   ),
    //   width: 350,
    //   className: "text-center",
    // },
    {
      title: "Tên danh mục",
      dataIndex: "name",
      render: (text) => <h6>{text}</h6>,
    },
    {
      title: "Danh mục",
      dataIndex: "parent",
      render: (parent) => <label>{parent?.name}</label>,
      // render: (parent) => (
      //   <>
      //     {parent ? (
      //       <Tag color="black" > {parent?.name.toUpperCase()}</Tag>
      //     ) : null}
      //   </>
      // ),
      width: 250,
    },
    {
      title: "Slug",
      dataIndex: "slug",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Màu nền",
      dataIndex: "homeBackground",
      className: "text-center",
      width: 50,
      render: (homeBackground) => (
        <div
          className="text-center"
          style={{
            width: 30,
            height: 30,
            marginLeft: "10px",
            backgroundColor: homeBackground.rgba,
          }}
        />
      ),
    },
    {
      title: "Thứ tự hiển thị",
      dataIndex: "order",
      className: "text-center",
      width: 50,
    },
    {
      title: "Trạng thái",
      dataIndex: "display",
      render: (display) => (
        <>
          {display === true && (
            <Tag color="green" key={display}>
              Hoạt động
            </Tag>
          )}
          {display === false && (
            <Tag color="red" key={display}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
      className: "text-center",
      width: 50,
    },
    // {
    //   title: "Hiển thị trang chủ",
    //   dataIndex: "displayHome",
    //   render: (displayHome) => (
    //     <>
    //       {displayHome === true && (
    //         <Tag color="green" key={displayHome}>
    //           Hiển thị
    //         </Tag>
    //       )}
    //       {displayHome === false && (
    //         <Tag color="red" key={displayHome}>
    //           Không hiển thị
    //         </Tag>
    //       )}
    //     </>
    //   ),
    //   className: "text-center",
    //   width: 50,
    // },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteCate(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      // fixed: "right",
    },
  ];

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm({});
    form.resetFields();
    setIsModalEditVisible(false);
  }, [form]);

  const onFinish = useCallback(
    (values) => {
      if (IsEdit) {
        updateCategory(values);
      } else {
        createCategory(values);
      }
    },
    [IsEdit]
  );
  const [value, setValue] = useState([""]);

  const showEditModal = (record) => {
    // setTitleModal("Sửa chuyên mục");
    // const avatarPath =
    //   record.image === null ||
    //   record.image === undefined ||
    //   record.image === "";
    // setImageNull(avatarPath ? null : record.image);
    setTitleModal("Sửa danh mục");

    setValue([record.parent?.id]);
    setColorBg(record.homeBackground);
    setValueForm({
      id: record.id,
      name: record.name,
      displayHome: record.displayHome,
      slug: record.slug,
      description: record.description,
      order: record.order,
      display: record.display,
      parent: record.parent?.id || "0",
      imagePath: null,
      seoKeywords: record.seoKeywords,
      seoDescription: record.seoDescription,
      seoTitle: record.seoTitle,
      seoIndex: record.seoIndex === "true" ? true : false,
    });
    setIsEdit(true);
    setIsModalEditVisible(true);
  };

  const showCreateModal = () => {
    setTitleModal("Thêm danh mục");
    console.log(categorySelect);
    setValue("0");
    setValueForm({
      parent: null,
      name: null,
      displayHome: false,
      slug: null,
      description: null,
      order: 0,
      homeBackground: null,
      display: false,
      parent: "0",
      imagePath: null,
      seoKeywords: null,
      seoDescription: null,
      seoTitle: null,
      seoIndex: false,
    });
    setIsEdit(false);
    setIsModalEditVisible(true);
  };

  const createCategory = (data) => {
    const parent = data.parent === "0" ? null : data.parent;

    const payload = {
      parent: parent,
      name: data.name,
      displayHome: data.displayHome,
      slug: data.slug,
      description: data.description,
      order: data.order,
      homeBackground: colorBg,
      display: data.display,
      imagePath: null,
      seoKeywords :data.seoKeywords,
      seoDescription  :data.seoDescription,
      seoTitle :data.seoTitle,
      seoIndex : data.seoIndex ? "true" : "false",
    };

    categoryApi.createCategory(payload).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditVisible(false);
          getCategory();
          getCategorySelect();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updateCategory = (data) => {
    const parent = data.parent === "0" ? null : data.parent;

    const payload = {
      name: data.name,
      displayHome: data.displayHome,
      slug: data.slug,
      description: data.description,
      order: data.order,
      homeBackground: colorBg,
      display: data.display,
      imagePath: fileImageUrl,
      parent: parent,
      seoKeywords :data.seoKeywords,
      seoDescription  :data.seoDescription,
      seoTitle :data.seoTitle,
      seoIndex : data.seoIndex ? "true" : "false",
    };

    console.log("updateCategory", payload);

    categoryApi.updateCategory(data.id, payload).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditVisible(false);
          getCategory();
          getCategorySelect();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const deleteCate = (record) => {
    const check = record?.totalArticles === 0;
    if (check) {
      const data = {
        ids: [record.id],
      };
      confirm({
        title: "Bạn có muốn xóa chuyên mục này không?",
        onOk() {
          categoryApi
            .deleteCategorys(data)
            .then((res) => {
              if (res) {
                message.success("Bạn đã xóa thành công chuyên mục");
                getCategory();
              } else {
                message.error("Xóa thất bại");
              }
            })
            .catch(() => {
              message.error("Xóa thất bại");
            });
        },
        onCancel() {},
      });
    } else {
      Swal.fire({
        title: "Thất bại!",
        text: `Chuyên mục này đang có ${record?.totalArticles} bài viết .Vui lòng kiểm tra lại! `,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const titleChange = useCallback(
    (values) => {
      const slug = slugify(values).toLowerCase();
      form.setFieldsValue({
        slug: slug,
      });
    },
    [form]
  );

  const onChangeSelect = (newValue) => {
    console.log(newValue);
    setValue(newValue);
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tìm kiếm theo tên chuyên mục</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                placeholder="Nhập tên chuyên mục"
                defaultValue={inputFilter.name}
                onChange={getCateDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6}>
              <label className="">Chuyên mục</label>

              <TreeSelect
                treeLine={
                  treeLine && {
                    showLeafIcon,
                  }
                }
                style={{
                  width: "100%",
                }}
                dropdownStyle={{
                  maxHeight: 400,
                  overflow: "auto",
                }}
                value="0"
                treeData={categorySelect}
                onChange={(e) => {
                  if (e !== "0") {
                    setFilter({ ...inputFilter, page: 1,parent: e });
                  } else {
                    const { parent, ...list } = inputFilter;
                    setFilter(list);
                  }
                }}
              ></TreeSelect>
            </Col>
            <Col span={6}>
              <label className="">Trạng thái</label>
              <br />

              <Select
                // value={inputFilter.role}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1,display: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value="true">Hoạt động</Option>
                <Option value="false">Không hoạt động</Option>
              </Select>
            </Col>
          </Row>
        </Card>

        <br />
        <Space size={10}>
          <Button type="dashed" size="small" onClick={() => showCreateModal()}>
            <EditOutlined /> &nbsp; Thêm chuyên mục
          </Button>
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstCategory}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>
      </div>

      <Modal
        title={titleModal}
        visible={isModalEditVisible}
        onOk={form.submit}
        width={800}
        onCancel={() => {
          closePopup();
        }}
      >
        <div>
          <Form
            initialValues={valueForm}
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Row>
              <Col span={12}>
                <Form.Item hidden={true} label="Id" name="id">
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Chuyên mục"
                  name="parent"
                  tooltip="Chuyên mục (để trống nếu là chuyên mục gốc)"
                >
                  <TreeSelect
                    treeLine={
                      treeLine && {
                        showLeafIcon,
                      }
                    }
                    style={{
                      width: "100%",
                    }}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: "auto",
                    }}
                    treeData={categorySelect}
                    value={value}
                    treeDefaultExpandedKeys={[value]}
                    onChange={onChangeSelect}
                  >
                    {/* <TreeNode value="leaf1" title="leaf1" /> */}
                  </TreeSelect>
                </Form.Item>

                <Form.Item
                  label="Tên chuyên mục"
                  name="name"
                  onChange={(e) => {
                    titleChange(e.target.value);
                  }}
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập tên!",
                    },
                  ]}
                >
                  <Input placeholder="Nhập tên ..." />
                </Form.Item>

                <Form.Item
                  label="Slug"
                  name="slug"
                  rules={[
                    {
                      pattern: new RegExp(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                      message: "Slug không đúng định dạng!",
                    },
                    {
                      required: true,
                      message: "Thiếu dữ liệu!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item label="Mô tả" name="description">
                  <TextArea rows={3} />
                </Form.Item>

                <Row gutter>
                  <Col>
                    <Form.Item
                      label="Thứ tự hiển thị"
                      name="order"
                      rules={[
                        {
                          required: true,
                          message: "Vui lòng nhập!",
                        },
                      ]}
                    >
                      <InputNumber min={0} />
                    </Form.Item>
                  </Col>
                  <Col offset={1}>
                    <Form.Item label="Màu nền" name="color">
                      <InputColor
                        initialValue={colorBg.hex}
                        onChange={setColorBg}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  label="Trạng thái"
                  valuePropName="checked"
                  name="display"
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={11} offset={1}>
                <Form.Item
                  label="No-Index"
                  name="seoIndex"
                  valuePropName="checked"
                >
                  <Switch></Switch>
                </Form.Item>

                <Form.Item
                  label="Thẻ tiêu đề"
                  name="seoTitle"
                  tooltip="Thẻ title"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Từ khóa meta"
                  name="seoKeywords"
                  tooltip="Từ khóa meta keywords"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Mô tả meta"
                  name="seoDescription"
                  tooltip="Thẻ meta description"
                >
                  <TextArea rows={4} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default ArticleCategory;
